module.exports = __webpack_public_path__ + "img/Enrique-Suarez-byn.e7c35d99.jpg";